import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { Fullscreen } from "../../components/fullscreen";
import { Nav } from "../../components/nav";
import { useLocale } from "../../stores/locale";
import { MaintenancePlanGroupList } from "./maintenance-plan-group-list";
import { MaintenancePlanList } from "./maintenance-plan-list";
import { MaintenancePropertyList } from "./maintenance-property-list";

export function Maintenance() {
  const { locale: t } = useLocale();

  return (
    <Fullscreen>
      <Nav
        className="mb-4"
        items={[
          { title: t.maintenance.planTab, slug: "/admin/maintenance/plan" },
          { title: t.maintenance.groupsTab, slug: "/admin/maintenance/groups" },
          {
            title: t.maintenance.propertiesTab,
            slug: "/admin/maintenance/property",
          },
        ]}
      />
      <Routes>
        <Route index element={<Navigate replace to="plan" />} />
        <Route element={<MaintenancePlanList />} path="/plan/*" />
        <Route element={<MaintenancePlanGroupList />} path="/groups/*" />
        <Route element={<MaintenancePropertyList />} path="/property/*" />
      </Routes>
      <Outlet />
    </Fullscreen>
  );
}
